<template>
  <b-modal id="formContactModal"
    title="Contact Us"
    ok-title="Send"
  >
    <form>
      <ShowErrors
        :errorMessages="errorMessages"
      />
      <div class="form-group">
        <label for="full_name">Name</label>
        <input type="text" class="form-control" name="full_name" placeholder="full name"
          v-model="userContact.full_name" v-validate="'required'" autofocus>

        <span v-show="errors.has('full_name')" class="input-error">
          Please enter your name so that we know what to call you.
        </span>
      </div>

      <div class="form-group">
        <label for="email">Email</label>
        <input type="email" class="form-control" name="email" placeholder="email address"
          v-model="userContact.email" v-validate="'required|email'">

        <span v-show="errors.has('email')" class="input-error">
          Please enter a valid email address where we can reply to you.
        </span>
      </div>

      <div class="form-group">
        <label for="message">Message</label>
        <textarea id="lead_message" rows="6" class="form-control" name="message"
          placeholder="Share any relevant details about your question."
          v-model="userContact.message" v-validate="'required|max:2000'">
        </textarea>

        <span v-show="errors.has('message')" class="input-error">
          Please tell us how we can help.
        </span>
      </div>
    </form>

    <template slot="modal-footer" slot-scope="{ ok, cancel }">
      <b-button variant="secondary" @click="cancel()">
        Cancel
      </b-button>
      <b-button variant="primary" @click="validate()">
        Send
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import GiftCardPublicService from '../../services/GiftCardPublicService'
import EventPublicService from '../../services/EventPublicService'
import ShowErrors from '../common/ShowErrors'

export default {
  name: 'ContactForm',
  components: {
    ShowErrors
  },
  props: {
    event: {
      required: false,
      type: Object
    },
    giftCard: {
      required: false,
      type: Object
    }
  },
  data: function () {
    return {
      errorMessages: [],
      userContact: {
        full_name: null,
        email: null,
        message: null
      }
    }
  },
  methods: {
    validate () {
      var self = this

      this.$validator.validateAll().then((result) => {
        if (result) {
          self.submitMessage()
        }
      })
    },
    submitMessage () {
      var self = this
      var sendMessageAction = null

      if (this.event) {
        sendMessageAction = EventPublicService.sendMessageToOwner(this.event.id, this.userContact)
      } else if (this.giftCard) {
        sendMessageAction = GiftCardPublicService.sendMessageToOwner(this.giftCard.id, this.userContact)
      } else {
        return false
      }

      sendMessageAction.then(function (response) {
        self.$bvModal.hide('formContactModal')
        self.$swal({
          title: 'We’ll get back to you as soon as possible.',
          type: 'success',
          confirmButtonColor: '#e1474d'
        })
      }).catch(function (error) {
        if (error) {
          self.$swal({
            title: 'Error sending message!',
            type: 'error'
          })

          var errorMsgs = error.response.data.message || error.response.data.error
          self.errorMessages.push(errorMsgs)
        }
      })
    }
  }
}
</script>
